// Reddit testing utilities
import { trackRedditEvent } from '@/analytics/reddit';

// Test Reddit Conversions API with the configured test ID
export const testRedditConversions = async () => {
  console.log('Testing Reddit Conversions API...');
  
  try {
    // Test a Lead conversion with test mode
    await trackRedditEvent(
      'Lead',
      { form_type: 'test_conversion' },
      { email: 'test@example.com' },
      true // Enable server-side tracking
    );
    
    console.log('Reddit Conversions API test sent successfully');
    return true;
  } catch (error) {
    console.error('Reddit Conversions API test failed:', error);
    return false;
  }
};

// Test ViewContent event
export const testRedditViewContent = async () => {
  console.log('Testing Reddit ViewContent...');
  
  try {
    await trackRedditEvent(
      'ViewContent',
      { content_type: 'landing_page' },
      { page: 'test' },
      true // Enable server-side tracking
    );
    
    console.log('Reddit ViewContent test sent successfully');
    return true;
  } catch (error) {
    console.error('Reddit ViewContent test failed:', error);
    return false;
  }
};

// Make test functions available globally for console testing
if (typeof window !== 'undefined') {
  (window as any).testRedditConversions = testRedditConversions;
  (window as any).testRedditViewContent = testRedditViewContent;
  console.log('Reddit test functions available: testRedditConversions(), testRedditViewContent()');
}